import { render } from "./AppDetailsComp.vue?vue&type=template&id=0d36f9bb&scoped=true"
import script from "./AppDetailsComp.vue?vue&type=script&lang=js"
export * from "./AppDetailsComp.vue?vue&type=script&lang=js"

import "./AppDetailsComp.vue?vue&type=style&index=0&id=0d36f9bb&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d36f9bb"]])

export default __exports__